const itensLC116 = Object.freeze([
    {
        "content": "01.01 - Análise E Desenvolvimento De Sistemas.",
        "id": "01.01 - Análise E Desenvolvimento De Sistemas."
    },
    {
        "content": "01.02 - Programação.",
        "id": "01.02 - Programação."
    },
    {
        "content": "01.03 - Processamento, Armazenamento Ou Hospedagem De Dados, Textos, Imagens, Vídeos, Páginas Eletrônicas, Aplicativos E Sistemas De Informação, Entre Outros Formatos, E Congêneres. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "01.03 - Processamento, Armazenamento Ou Hospedagem De Dados, Textos, Imagens, Vídeos, Páginas Eletrônicas, Aplicativos E Sistemas De Informação, Entre Outros Formatos, E Congêneres. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "01.04 - Elaboração De Programas De Computadores, Inclusive De Jogos Eletrônicos, Independentemente Da Arquitetura Construtiva Da Máquina Em Que O Programa Será Executado, Incluindo Tablets, Smartphones E Congêneres. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "01.04 - Elaboração De Programas De Computadores, Inclusive De Jogos Eletrônicos, Independentemente Da Arquitetura Construtiva Da Máquina Em Que O Programa Será Executado, Incluindo Tablets, Smartphones E Congêneres. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "01.05 - Licenciamento Ou Cessão De Direito De Uso De Programas De Computação.",
        "id": "01.05 - Licenciamento Ou Cessão De Direito De Uso De Programas De Computação."
    },
    {
        "content": "01.06 - Assessoria E Consultoria Em Informática.",
        "id": "01.06 - Assessoria E Consultoria Em Informática."
    },
    {
        "content": "01.07 - Suporte Técnico Em Informática, Inclusive Instalação, Configuração E Manutenção De Programas De Computação E Bancos De Dados.",
        "id": "01.07 - Suporte Técnico Em Informática, Inclusive Instalação, Configuração E Manutenção De Programas De Computação E Bancos De Dados."
    },
    {
        "content": "01.08 - Planejamento, Confecção, Manutenção E Atualização De Páginas Eletrônicas.",
        "id": "01.08 - Planejamento, Confecção, Manutenção E Atualização De Páginas Eletrônicas."
    },
    {
        "content": "01.09 - Disponibilização, Sem Cessão Definitiva, De Conteúdos De Áudio, Vídeo, Imagem E Texto Por Meio Da Internet, Respeitada A Imunidade De Livros, Jornais E Periódicos (Exceto A Distribuição De Conteúdos Pelas Prestadoras De Serviço De Acesso Condicionado, De Que Trata A Lei No 12.485, De 12 De Setembro De 2011, Sujeita Ao ICMS). (Incluído Pela Lei Complementar Nº 157, De 2016)",
        "id": "01.09 - Disponibilização, Sem Cessão Definitiva, De Conteúdos De Áudio, Vídeo, Imagem E Texto Por Meio Da Internet, Respeitada A Imunidade De Livros, Jornais E Periódicos (Exceto A Distribuição De Conteúdos Pelas Prestadoras De Serviço De Acesso Condicionado, De Que Trata A Lei No 12.485, De 12 De Setembro De 2011, Sujeita Ao ICMS). (Incluído Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "02.01 - Serviços De Pesquisas E Desenvolvimento De Qualquer Natureza.",
        "id": "02.01 - Serviços De Pesquisas E Desenvolvimento De Qualquer Natureza."
    },
    {
        "content": "03.02 - Cessão De Direito De Uso De Marcas E De Sinais De Propaganda.",
        "id": "03.02 - Cessão De Direito De Uso De Marcas E De Sinais De Propaganda."
    },
    {
        "content": "03.03 - Exploração De Salões De Festas, Centro De Convenções, Escritórios Virtuais, Stands, Quadras Esportivas, Estádios, Ginásios, Auditórios, Casas De Espetáculos, Parques De Diversões, Canchas E Congêneres, Para Realização De Eventos Ou Negócios De Qualquer Natureza.",
        "id": "03.03 - Exploração De Salões De Festas, Centro De Convenções, Escritórios Virtuais, Stands, Quadras Esportivas, Estádios, Ginásios, Auditórios, Casas De Espetáculos, Parques De Diversões, Canchas E Congêneres, Para Realização De Eventos Ou Negócios De Qualquer Natureza."
    },
    {
        "content": "03.04 - Locação, Sublocação, Arrendamento, Direito De Passagem Ou Permissão De Uso, Compartilhado Ou Não, De Ferrovia, Rodovia, Postes, Cabos, Dutos E Condutos De Qualquer Natureza.",
        "id": "03.04 - Locação, Sublocação, Arrendamento, Direito De Passagem Ou Permissão De Uso, Compartilhado Ou Não, De Ferrovia, Rodovia, Postes, Cabos, Dutos E Condutos De Qualquer Natureza."
    },
    {
        "content": "03.05 - Cessão De Andaimes, Palcos, Coberturas E Outras Estruturas De Uso Temporário.",
        "id": "03.05 - Cessão De Andaimes, Palcos, Coberturas E Outras Estruturas De Uso Temporário."
    },
    {
        "content": "04.01 - Medicina E Biomedicina.",
        "id": "04.01 - Medicina E Biomedicina."
    },
    {
        "content": "04.02 - Análises Clínicas, Patologia, Eletricidade Médica, Radioterapia, Quimioterapia, Ultra-Sonografia, Ressonância Magnética, Radiologia, Tomografia E Congêneres.",
        "id": "04.02 - Análises Clínicas, Patologia, Eletricidade Médica, Radioterapia, Quimioterapia, Ultra-Sonografia, Ressonância Magnética, Radiologia, Tomografia E Congêneres."
    },
    {
        "content": "04.03 - Hospitais, Clínicas, Laboratórios, Sanatórios, Manicômios, Casas De Saúde, Prontos-Socorros, Ambulatórios E Congêneres.",
        "id": "04.03 - Hospitais, Clínicas, Laboratórios, Sanatórios, Manicômios, Casas De Saúde, Prontos-Socorros, Ambulatórios E Congêneres."
    },
    {
        "content": "04.04 - Instrumentação Cirúrgica.",
        "id": "04.04 - Instrumentação Cirúrgica."
    },
    {
        "content": "04.05 - Acupuntura.",
        "id": "04.05 - Acupuntura."
    },
    {
        "content": "04.06 - Enfermagem, Inclusive Serviços Auxiliares.",
        "id": "04.06 - Enfermagem, Inclusive Serviços Auxiliares."
    },
    {
        "content": "04.07 - Serviços farmacêuticos",
        "id": "04.07 - Serviços farmacêuticos"
    },
    {
        "content": "04.08 - Terapia Ocupacional, Fisioterapia E Fonoaudiologia.",
        "id": "04.08 - Terapia Ocupacional, Fisioterapia E Fonoaudiologia."
    },
    {
        "content": "04.09 - Terapias De Qualquer Espécie Destinadas Ao Tratamento Físico, Orgânico E Mental.",
        "id": "04.09 - Terapias De Qualquer Espécie Destinadas Ao Tratamento Físico, Orgânico E Mental."
    },
    {
        "content": "04.10 - Nutrição.",
        "id": "04.10 - Nutrição."
    },
    {
        "content": "04.11 - Obstetrícia.",
        "id": "04.11 - Obstetrícia."
    },
    {
        "content": "04.12 - Odontologia.",
        "id": "04.12 - Odontologia."
    },
    {
        "content": "04.13 - Ortóptica.",
        "id": "04.13 - Ortóptica."
    },
    {
        "content": "04.14 - Próteses Sob Encomenda.",
        "id": "04.14 - Próteses Sob Encomenda."
    },
    {
        "content": "04.15 - Psicanálise.",
        "id": "04.15 - Psicanálise."
    },
    {
        "content": "04.16 - Psicologia.",
        "id": "04.16 - Psicologia."
    },
    {
        "content": "04.17 - Casas De Repouso E De Recuperação, Creches, Asilos E Congêneres.",
        "id": "04.17 - Casas De Repouso E De Recuperação, Creches, Asilos E Congêneres."
    },
    {
        "content": "04.18 - Inseminação Artificial, Fertilização In Vitro E Congêneres.",
        "id": "04.18 - Inseminação Artificial, Fertilização In Vitro E Congêneres."
    },
    {
        "content": "04.19 - Bancos De Sangue, Leite, Pele, Olhos, Óvulos, Sêmen E Congêneres.",
        "id": "04.19 - Bancos De Sangue, Leite, Pele, Olhos, Óvulos, Sêmen E Congêneres."
    },
    {
        "content": "04.20 - Coleta De Sangue, Leite, Tecidos, Sêmen, Órgãos E Materiais Biológicos De Qualquer Espécie.",
        "id": "04.20 - Coleta De Sangue, Leite, Tecidos, Sêmen, Órgãos E Materiais Biológicos De Qualquer Espécie."
    },
    {
        "content": "04.21 - Unidade De Atendimento, Assistência Ou Tratamento Móvel E Congêneres.",
        "id": "04.21 - Unidade De Atendimento, Assistência Ou Tratamento Móvel E Congêneres."
    },
    {
        "content": "04.22 - Planos De Medicina De Grupo Ou Individual E Convênios Para Prestação De Assistência Médica, Hospitalar, Odontológica E Congêneres.",
        "id": "04.22 - Planos De Medicina De Grupo Ou Individual E Convênios Para Prestação De Assistência Médica, Hospitalar, Odontológica E Congêneres."
    },
    {
        "content": "04.23 - Outros Planos De Saúde Que Se Cumpram Através De Serviços De Terceiros Contratados, Credenciados, Cooperados Ou Apenas Pagos Pelo Operador Do Plano Mediante Indicação Do Beneficiário.",
        "id": "04.23 - Outros Planos De Saúde Que Se Cumpram Através De Serviços De Terceiros Contratados, Credenciados, Cooperados Ou Apenas Pagos Pelo Operador Do Plano Mediante Indicação Do Beneficiário."
    },
    {
        "content": "05.01 - Medicina Veterinária E Zootecnia.",
        "id": "05.01 - Medicina Veterinária E Zootecnia."
    },
    {
        "content": "05.02 - Hospitais, Clínicas, Ambulatórios, Prontos-Socorros E Congêneres, Na Área Veterinária.",
        "id": "05.02 - Hospitais, Clínicas, Ambulatórios, Prontos-Socorros E Congêneres, Na Área Veterinária."
    },
    {
        "content": "05.03 - Laboratórios De Análise Na Área Veterinária.",
        "id": "05.03 - Laboratórios De Análise Na Área Veterinária."
    },
    {
        "content": "05.04 - Inseminação Artificial, Fertilização In Vitro E Congêneres.",
        "id": "05.04 - Inseminação Artificial, Fertilização In Vitro E Congêneres."
    },
    {
        "content": "05.05 - Bancos De Sangue E De Órgãos E Congêneres.",
        "id": "05.05 - Bancos De Sangue E De Órgãos E Congêneres."
    },
    {
        "content": "05.06 - Coleta De Sangue, Leite, Tecidos, Sêmen, Órgãos E Materiais Biológicos De Qualquer Espécie.",
        "id": "05.06 - Coleta De Sangue, Leite, Tecidos, Sêmen, Órgãos E Materiais Biológicos De Qualquer Espécie."
    },
    {
        "content": "05.07 - Unidade De Atendimento, Assistência Ou Tratamento Móvel E Congêneres.",
        "id": "05.07 - Unidade De Atendimento, Assistência Ou Tratamento Móvel E Congêneres."
    },
    {
        "content": "05.08 - Guarda, Tratamento, Amestramento, Embelezamento, Alojamento E Congêneres.",
        "id": "05.08 - Guarda, Tratamento, Amestramento, Embelezamento, Alojamento E Congêneres."
    },
    {
        "content": "05.09 - Planos De Atendimento E Assistência Médico-Veterinária.",
        "id": "05.09 - Planos De Atendimento E Assistência Médico-Veterinária."
    },
    {
        "content": "06.01 - Barbearia, Cabeleireiros, Manicuros, Pedicuros E Congêneres.",
        "id": "06.01 - Barbearia, Cabeleireiros, Manicuros, Pedicuros E Congêneres."
    },
    {
        "content": "06.02 - Esteticistas, Tratamento De Pele, Depilação E Congêneres.",
        "id": "06.02 - Esteticistas, Tratamento De Pele, Depilação E Congêneres."
    },
    {
        "content": "06.03 - Banhos, Duchas, Sauna, Massagens E Congêneres.",
        "id": "06.03 - Banhos, Duchas, Sauna, Massagens E Congêneres."
    },
    {
        "content": "06.04 - Ginástica, Dança, Esportes, Natação, Artes Marciais E Demais Atividades Físicas.",
        "id": "06.04 - Ginástica, Dança, Esportes, Natação, Artes Marciais E Demais Atividades Físicas."
    },
    {
        "content": "06.05 - Centros De Emagrecimento, Spa E Congêneres.",
        "id": "06.05 - Centros De Emagrecimento, Spa E Congêneres."
    },
    {
        "content": "06.06 - Aplicação De Tatuagens, Piercings E Congêneres.",
        "id": "06.06 - Aplicação De Tatuagens, Piercings E Congêneres."
    },
    {
        "content": "07.01 - Engenharia, Agronomia, Agrimensura, Arquitetura, Geologia, Urbanismo, Paisagismo E Congêneres.",
        "id": "07.01 - Engenharia, Agronomia, Agrimensura, Arquitetura, Geologia, Urbanismo, Paisagismo E Congêneres."
    },
    {
        "content": "07.02 - Execução, Por Administração, Empreitada Ou Subempreitada, De Obras De Construção Civil, Hidráulica Ou Elétrica E De Outras Obras Semelhantes, Inclusive Sondagem, Perfuração De Poços, Escavação, Drenagem E Irrigação, Terraplanagem, Pavimentação, Concretagem E A Instalação E Montagem De Produtos, Peças E Equipamentos (Exceto O Fornecimento De Mercadorias Produzidas Pelo Prestador De Serviços Fora Do Local Da Prestação Dos Serviços, Que Fica Sujeito Ao ICMS).",
        "id": "07.02 - Execução, Por Administração, Empreitada Ou Subempreitada, De Obras De Construção Civil, Hidráulica Ou Elétrica E De Outras Obras Semelhantes, Inclusive Sondagem, Perfuração De Poços, Escavação, Drenagem E Irrigação, Terraplanagem, Pavimentação, Concretagem E A Instalação E Montagem De Produtos, Peças E Equipamentos (Exceto O Fornecimento De Mercadorias Produzidas Pelo Prestador De Serviços Fora Do Local Da Prestação Dos Serviços, Que Fica Sujeito Ao ICMS)."
    },
    {
        "content": "07.03 - Elaboração De Planos Diretores, Estudos De Viabilidade, Estudos Organizacionais E Outros, Relacionados Com Obras E Serviços De Engenharia; Elaboração De Anteprojetos, Projetos Básicos E Projetos Executivos Para Trabalhos De Engenharia.",
        "id": "07.03 - Elaboração De Planos Diretores, Estudos De Viabilidade, Estudos Organizacionais E Outros, Relacionados Com Obras E Serviços De Engenharia; Elaboração De Anteprojetos, Projetos Básicos E Projetos Executivos Para Trabalhos De Engenharia."
    },
    {
        "content": "07.04 - Demolição.",
        "id": "07.04 - Demolição."
    },
    {
        "content": "07.05 - Reparação, Conservação E Reforma De Edifícios, Estradas, Pontes, Portos E Congêneres (Exceto O Fornecimento De Mercadorias Produzidas Pelo Prestador Dos Serviços, Fora Do Local Da Prestação Dos Serviços, Que Fica Sujeito Ao ICMS).",
        "id": "07.05 - Reparação, Conservação E Reforma De Edifícios, Estradas, Pontes, Portos E Congêneres (Exceto O Fornecimento De Mercadorias Produzidas Pelo Prestador Dos Serviços, Fora Do Local Da Prestação Dos Serviços, Que Fica Sujeito Ao ICMS)."
    },
    {
        "content": "07.06 - Colocação E Instalação De Tapetes, Carpetes, Assoalhos, Cortinas, Revestimentos De Parede, Vidros, Divisórias, Placas De Gesso E Congêneres, Com Material Fornecido Pelo Tomador Do Serviço.",
        "id": "07.06 - Colocação E Instalação De Tapetes, Carpetes, Assoalhos, Cortinas, Revestimentos De Parede, Vidros, Divisórias, Placas De Gesso E Congêneres, Com Material Fornecido Pelo Tomador Do Serviço."
    },
    {
        "content": "07.07 - Recuperação, Raspagem, Polimento E Lustração De Pisos E Congêneres.",
        "id": "07.07 - Recuperação, Raspagem, Polimento E Lustração De Pisos E Congêneres."
    },
    {
        "content": "07.08 - Calafetação.",
        "id": "07.08 - Calafetação."
    },
    {
        "content": "07.09 - Varrição, Coleta, Remoção, Incineração, Tratamento, Reciclagem, Separação E Destinação Final De Lixo, Rejeitos E Outros Resíduos Quaisquer.",
        "id": "07.09 - Varrição, Coleta, Remoção, Incineração, Tratamento, Reciclagem, Separação E Destinação Final De Lixo, Rejeitos E Outros Resíduos Quaisquer."
    },
    {
        "content": "07.10 - Limpeza, Manutenção E Conservação De Vias E Logradouros Públicos, Imóveis, Chaminés, Piscinas, Parques, Jardins E Congêneres.",
        "id": "07.10 - Limpeza, Manutenção E Conservação De Vias E Logradouros Públicos, Imóveis, Chaminés, Piscinas, Parques, Jardins E Congêneres."
    },
    {
        "content": "07.11 - Decoração E Jardinagem, Inclusive Corte E Poda De Árvores.",
        "id": "07.11 - Decoração E Jardinagem, Inclusive Corte E Poda De Árvores."
    },
    {
        "content": "07.12 - Controle E Tratamento De Efluentes De Qualquer Natureza E De Agentes Físicos, Químicos E Biológicos.",
        "id": "07.12 - Controle E Tratamento De Efluentes De Qualquer Natureza E De Agentes Físicos, Químicos E Biológicos."
    },
    {
        "content": "07.13 - Dedetização, Desinfecção, Desinsetização, Imunização, Higienização, Desratização, Pulverização E Congêneres.",
        "id": "07.13 - Dedetização, Desinfecção, Desinsetização, Imunização, Higienização, Desratização, Pulverização E Congêneres."
    },
    {
        "content": "07.14 - (Vetado)",
        "id": "07.14 - (Vetado)"
    },
    {
        "content": "07.15 - (Vetado)",
        "id": "07.15 - (Vetado)"
    },
    {
        "content": "07.16 - Florestamento, Reflorestamento, Semeadura, Adubação, Reparação De Solo, Plantio, Silagem, Colheita, Corte E Descascamento De Árvores, Silvicultura, Exploração Florestal E Dos Serviços Congêneres Indissociáveis Da Formação, Manutenção E Colheita De Florestas, Para Quaisquer Fins E Por Quaisquer Meios. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "07.16 - Florestamento, Reflorestamento, Semeadura, Adubação, Reparação De Solo, Plantio, Silagem, Colheita, Corte E Descascamento De Árvores, Silvicultura, Exploração Florestal E Dos Serviços Congêneres Indissociáveis Da Formação, Manutenção E Colheita De Florestas, Para Quaisquer Fins E Por Quaisquer Meios. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "07.17 - Escoramento, Contenção De Encostas E Serviços Congêneres.",
        "id": "07.17 - Escoramento, Contenção De Encostas E Serviços Congêneres."
    },
    {
        "content": "07.18 - Limpeza E Dragagem De Rios, Portos, Canais, Baías, Lagos, Lagoas, Represas, Açudes E Congêneres.",
        "id": "07.18 - Limpeza E Dragagem De Rios, Portos, Canais, Baías, Lagos, Lagoas, Represas, Açudes E Congêneres."
    },
    {
        "content": "07.19 - Acompanhamento E Fiscalização Da Execução De Obras De Engenharia, Arquitetura E Urbanismo.",
        "id": "07.19 - Acompanhamento E Fiscalização Da Execução De Obras De Engenharia, Arquitetura E Urbanismo."
    },
    {
        "content": "07.20 - Aerofotogrametria (Inclusive Interpretação), Cartografia, Mapeamento, Levantamentos Topográficos, Batimétricos, Geográficos, Geodésicos, Geológicos, Geofísicos E Congêneres.",
        "id": "07.20 - Aerofotogrametria (Inclusive Interpretação), Cartografia, Mapeamento, Levantamentos Topográficos, Batimétricos, Geográficos, Geodésicos, Geológicos, Geofísicos E Congêneres."
    },
    {
        "content": "07.21 - Pesquisa, Perfuração, Cimentação, Mergulho, Perfilagem, Concretação, Testemunhagem, Pescaria, Estimulação E Outros Serviços Relacionados Com A Exploração E Explotação De Petróleo, Gás Natural E De Outros Recursos Minerais.",
        "id": "07.21 - Pesquisa, Perfuração, Cimentação, Mergulho, Perfilagem, Concretação, Testemunhagem, Pescaria, Estimulação E Outros Serviços Relacionados Com A Exploração E Explotação De Petróleo, Gás Natural E De Outros Recursos Minerais."
    },
    {
        "content": "07.22 - Nucleação E Bombardeamento De Nuvens E Congêneres.",
        "id": "07.22 - Nucleação E Bombardeamento De Nuvens E Congêneres."
    },
    {
        "content": "08.01 - Ensino Regular Pré-Escolar, Fundamental, Médio E Superior.",
        "id": "08.01 - Ensino Regular Pré-Escolar, Fundamental, Médio E Superior."
    },
    {
        "content": "08.02 - Instrução, Treinamento, Orientação Pedagógica E Educacional, Avaliação De Conhecimentos De Qualquer Natureza.",
        "id": "08.02 - Instrução, Treinamento, Orientação Pedagógica E Educacional, Avaliação De Conhecimentos De Qualquer Natureza."
    },
    {
        "content": "09.01 - Hospedagem De Qualquer Natureza Em Hotéis, Apart-Service Condominiais, Flat, Apart-Hotéis, Hotéis Residência, Residence-Service, Suite Service, Hotelaria Marítima, Motéis, Pensões E Congêneres; Ocupação Por Temporada Com Fornecimento De Serviço (O Valor Da Alimentação E Gorjeta, Quando Incluído No Preço Da Diária, Fica Sujeito Ao Imposto Sobre Serviços).",
        "id": "09.01 - Hospedagem De Qualquer Natureza Em Hotéis, Apart-Service Condominiais, Flat, Apart-Hotéis, Hotéis Residência, Residence-Service, Suite Service, Hotelaria Marítima, Motéis, Pensões E Congêneres; Ocupação Por Temporada Com Fornecimento De Serviço (O Valor Da Alimentação E Gorjeta, Quando Incluído No Preço Da Diária, Fica Sujeito Ao Imposto Sobre Serviços)."
    },
    {
        "content": "09.02 - Agenciamento, Organização, Promoção, Intermediação E Execução De Programas De Turismo, Passeios, Viagens, Excursões, Hospedagens E Congêneres.",
        "id": "09.02 - Agenciamento, Organização, Promoção, Intermediação E Execução De Programas De Turismo, Passeios, Viagens, Excursões, Hospedagens E Congêneres."
    },
    {
        "content": "09.03 - Guias De Turismo.",
        "id": "09.03 - Guias De Turismo."
    },
    {
        "content": "10.01 - Agenciamento, Corretagem Ou Intermediação De Câmbio, De Seguros, De Cartões De Crédito, De Planos De Saúde E De Planos De Previdência Privada.",
        "id": "10.01 - Agenciamento, Corretagem Ou Intermediação De Câmbio, De Seguros, De Cartões De Crédito, De Planos De Saúde E De Planos De Previdência Privada."
    },
    {
        "content": "10.02 - Agenciamento, Corretagem Ou Intermediação De Títulos Em Geral, Valores Mobiliários E Contratos Quaisquer.",
        "id": "10.02 - Agenciamento, Corretagem Ou Intermediação De Títulos Em Geral, Valores Mobiliários E Contratos Quaisquer."
    },
    {
        "content": "10.03 - Agenciamento, Corretagem Ou Intermediação De Direitos De Propriedade Industrial, Artística Ou Literária.",
        "id": "10.03 - Agenciamento, Corretagem Ou Intermediação De Direitos De Propriedade Industrial, Artística Ou Literária."
    },
    {
        "content": "10.04 - Agenciamento, Corretagem Ou Intermediação De Contratos De Arrendamento Mercantil (Leasing), De Franquia (Franchising) E De Faturização (Factoring).",
        "id": "10.04 - Agenciamento, Corretagem Ou Intermediação De Contratos De Arrendamento Mercantil (Leasing), De Franquia (Franchising) E De Faturização (Factoring)."
    },
    {
        "content": "10.05 - Agenciamento, Corretagem Ou Intermediação De Bens Móveis Ou Imóveis, Não Abrangidos Em Outros Itens Ou Subitens, Inclusive Aqueles Realizados No Âmbito De Bolsas De Mercadorias E Futuros, Por Quaisquer Meios.",
        "id": "10.05 - Agenciamento, Corretagem Ou Intermediação De Bens Móveis Ou Imóveis, Não Abrangidos Em Outros Itens Ou Subitens, Inclusive Aqueles Realizados No Âmbito De Bolsas De Mercadorias E Futuros, Por Quaisquer Meios."
    },
    {
        "content": "10.06 - Agenciamento Marítimo.",
        "id": "10.06 - Agenciamento Marítimo."
    },
    {
        "content": "10.07 - Agenciamento De Notícias.",
        "id": "10.07 - Agenciamento De Notícias."
    },
    {
        "content": "10.08 - Agenciamento De Publicidade E Propaganda, Inclusive O Agenciamento De Veiculação Por Quaisquer Meios.",
        "id": "10.08 - Agenciamento De Publicidade E Propaganda, Inclusive O Agenciamento De Veiculação Por Quaisquer Meios."
    },
    {
        "content": "10.09 - Representação De Qualquer Natureza, Inclusive Comercial.",
        "id": "10.09 - Representação De Qualquer Natureza, Inclusive Comercial."
    },
    {
        "content": "10.10 - Distribuição De Bens De Terceiros.",
        "id": "10.10 - Distribuição De Bens De Terceiros."
    },
    {
        "content": "11.01 - Guarda E Estacionamento De Veículos Terrestres Automotores, De Aeronaves E De Embarcações.",
        "id": "11.01 - Guarda E Estacionamento De Veículos Terrestres Automotores, De Aeronaves E De Embarcações."
    },
    {
        "content": "11.02 - Vigilância, Segurança Ou Monitoramento De Bens E Pessoas.",
        "id": "11.02 - Vigilância, Segurança Ou Monitoramento De Bens E Pessoas."
    },
    {
        "content": "11.03 - Escolta, Inclusive De Veículos E Cargas.",
        "id": "11.03 - Escolta, Inclusive De Veículos E Cargas."
    },
    {
        "content": "11.04 - Armazenamento, Depósito, Carga, Descarga, Arrumação E Guarda De Bens De Qualquer Espécie.",
        "id": "11.04 - Armazenamento, Depósito, Carga, Descarga, Arrumação E Guarda De Bens De Qualquer Espécie."
    },
    {
        "content": "11.05 - Vigilância, Segurança Ou Monitoramento De Bens, Pessoas E Semoventes. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "11.05 - Vigilância, Segurança Ou Monitoramento De Bens, Pessoas E Semoventes. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "12.01 - Espetáculos Teatrais.",
        "id": "12.01 - Espetáculos Teatrais."
    },
    {
        "content": "12.02 - Exibições Cinematográficas.",
        "id": "12.02 - Exibições Cinematográficas."
    },
    {
        "content": "12.03 - Espetáculos Circenses.",
        "id": "12.03 - Espetáculos Circenses."
    },
    {
        "content": "12.04 - Programas De Auditório.",
        "id": "12.04 - Programas De Auditório."
    },
    {
        "content": "12.05 - Parques De Diversões, Centros De Lazer E Congêneres.",
        "id": "12.05 - Parques De Diversões, Centros De Lazer E Congêneres."
    },
    {
        "content": "12.06 - Boates, Taxi-Dancing E Congêneres.",
        "id": "12.06 - Boates, Taxi-Dancing E Congêneres."
    },
    {
        "content": "12.07 - Shows, Ballet, Danças, Desfiles, Bailes, Óperas, Concertos, Recitais, Festivais E Congêneres.",
        "id": "12.07 - Shows, Ballet, Danças, Desfiles, Bailes, Óperas, Concertos, Recitais, Festivais E Congêneres."
    },
    {
        "content": "12.08 - Feiras, Exposições, Congressos E Congêneres.",
        "id": "12.08 - Feiras, Exposições, Congressos E Congêneres."
    },
    {
        "content": "12.09 - Bilhares, Boliches E Diversões Eletrônicas Ou Não.",
        "id": "12.09 - Bilhares, Boliches E Diversões Eletrônicas Ou Não."
    },
    {
        "content": "12.10 - Corridas E Competições De Animais.",
        "id": "12.10 - Corridas E Competições De Animais."
    },
    {
        "content": "12.11 - Competições Esportivas Ou De Destreza Física Ou Intelectual, Com Ou Sem A Participação Do Espectador.",
        "id": "12.11 - Competições Esportivas Ou De Destreza Física Ou Intelectual, Com Ou Sem A Participação Do Espectador."
    },
    {
        "content": "12.12 - Execução De Música.",
        "id": "12.12 - Execução De Música."
    },
    {
        "content": "12.13 - Produção, Mediante Ou Sem Encomenda Prévia, De Eventos, Espetáculos, Entrevistas, Shows, Ballet, Danças, Desfiles, Bailes, Teatros, Óperas, Concertos, Recitais, Festivais E Congêneres.",
        "id": "12.13 - Produção, Mediante Ou Sem Encomenda Prévia, De Eventos, Espetáculos, Entrevistas, Shows, Ballet, Danças, Desfiles, Bailes, Teatros, Óperas, Concertos, Recitais, Festivais E Congêneres."
    },
    {
        "content": "12.14 - Fornecimento De Música Para Ambientes Fechados Ou Não, Mediante Transmissão Por Qualquer Processo.",
        "id": "12.14 - Fornecimento De Música Para Ambientes Fechados Ou Não, Mediante Transmissão Por Qualquer Processo."
    },
    {
        "content": "12.15 - Desfiles De Blocos Carnavalescos Ou Folclóricos, Trios Elétricos E Congêneres.",
        "id": "12.15 - Desfiles De Blocos Carnavalescos Ou Folclóricos, Trios Elétricos E Congêneres."
    },
    {
        "content": "12.16 - Exibição De Filmes, Entrevistas, Musicais, Espetáculos, Shows, Concertos, Desfiles, Óperas, Competições Esportivas, De Destreza Intelectual Ou Congêneres.",
        "id": "12.16 - Exibição De Filmes, Entrevistas, Musicais, Espetáculos, Shows, Concertos, Desfiles, Óperas, Competições Esportivas, De Destreza Intelectual Ou Congêneres."
    },
    {
        "content": "12.17 - Recreação E Animação, Inclusive Em Festas E Eventos De Qualquer Natureza.",
        "id": "12.17 - Recreação E Animação, Inclusive Em Festas E Eventos De Qualquer Natureza."
    },
    {
        "content": "13.02 - Fonografia Ou Gravação De Sons, Inclusive Trucagem, Dublagem, Mixagem E Congêneres.",
        "id": "13.02 - Fonografia Ou Gravação De Sons, Inclusive Trucagem, Dublagem, Mixagem E Congêneres."
    },
    {
        "content": "13.03 - Fotografia E Cinematografia, Inclusive Revelação, Ampliação, Cópia, Reprodução, Trucagem E Congêneres.",
        "id": "13.03 - Fotografia E Cinematografia, Inclusive Revelação, Ampliação, Cópia, Reprodução, Trucagem E Congêneres."
    },
    {
        "content": "13.04 - Reprografia, Microfilmagem E Digitalização.",
        "id": "13.04 - Reprografia, Microfilmagem E Digitalização."
    },
    {
        "content": "13.05 - Composição Gráfica, Inclusive Confecção De Impressos Gráficos, Fotocomposição, Clicheria, Zincografia, Litografia E Fotolitografia, Exceto Se Destinados A Posterior Operação De Comercialização Ou Industrialização, Ainda Que Incorporados, De Qualquer Forma, A Outra Mercadoria Que Deva Ser Objeto De Posterior Circulação, Tais Como Bulas, Rótulos, Etiquetas, Caixas, Cartuchos, Embalagens E Manuais Técnicos E De Instrução, Quando Ficarão Sujeitos Ao ICMS. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "13.05 - Composição Gráfica, Inclusive Confecção De Impressos Gráficos, Fotocomposição, Clicheria, Zincografia, Litografia E Fotolitografia, Exceto Se Destinados A Posterior Operação De Comercialização Ou Industrialização, Ainda Que Incorporados, De Qualquer Forma, A Outra Mercadoria Que Deva Ser Objeto De Posterior Circulação, Tais Como Bulas, Rótulos, Etiquetas, Caixas, Cartuchos, Embalagens E Manuais Técnicos E De Instrução, Quando Ficarão Sujeitos Ao ICMS. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "14.01 - Lubrificação, Limpeza, Lustração, Revisão, Carga E Recarga, Conserto, Restauração, Blindagem, Manutenção E Conservação De Máquinas, Veículos, Aparelhos, Equipamentos, Motores, Elevadores Ou De Qualquer Objeto (Exceto Peças E Partes Empregadas, Que Ficam Sujeitas Ao ICMS).",
        "id": "14.01 - Lubrificação, Limpeza, Lustração, Revisão, Carga E Recarga, Conserto, Restauração, Blindagem, Manutenção E Conservação De Máquinas, Veículos, Aparelhos, Equipamentos, Motores, Elevadores Ou De Qualquer Objeto (Exceto Peças E Partes Empregadas, Que Ficam Sujeitas Ao ICMS)."
    },
    {
        "content": "14.02 - Assistência Técnica.",
        "id": "14.02 - Assistência Técnica."
    },
    {
        "content": "14.03 - Recondicionamento De Motores (Exceto Peças E Partes Empregadas, Que Ficam Sujeitas Ao ICMS).",
        "id": "14.03 - Recondicionamento De Motores (Exceto Peças E Partes Empregadas, Que Ficam Sujeitas Ao ICMS)."
    },
    {
        "content": "14.04 - Recauchutagem Ou Regeneração De Pneus.",
        "id": "14.04 - Recauchutagem Ou Regeneração De Pneus."
    },
    {
        "content": "14.05 - Restauração, Recondicionamento, Acondicionamento, Pintura, Beneficiamento, Lavagem, Secagem, Tingimento, Galvanoplastia, Anodização, Corte, Recorte, Plastificação, Costura, Acabamento, Polimento E Congêneres De Objetos Quaisquer.",
        "id": "14.05 - Restauração, Recondicionamento, Acondicionamento, Pintura, Beneficiamento, Lavagem, Secagem, Tingimento, Galvanoplastia, Anodização, Corte, Recorte, Plastificação, Costura, Acabamento, Polimento E Congêneres De Objetos Quaisquer."
    },
    {
        "content": "14.06 - Instalação E Montagem De Aparelhos, Máquinas E Equipamentos, Inclusive Montagem Industrial, Prestados Ao Usuário Final, Exclusivamente Com Material Por Ele Fornecido.",
        "id": "14.06 - Instalação E Montagem De Aparelhos, Máquinas E Equipamentos, Inclusive Montagem Industrial, Prestados Ao Usuário Final, Exclusivamente Com Material Por Ele Fornecido."
    },
    {
        "content": "14.07 - Colocação De Molduras E Congêneres.",
        "id": "14.07 - Colocação De Molduras E Congêneres."
    },
    {
        "content": "14.08 - Encadernação, Gravação E Douração De Livros, Revistas E Congêneres.",
        "id": "14.08 - Encadernação, Gravação E Douração De Livros, Revistas E Congêneres."
    },
    {
        "content": "14.09 - Alfaiataria E Costura, Quando O Material For Fornecido Pelo Usuário Final, Exceto Aviamento.",
        "id": "14.09 - Alfaiataria E Costura, Quando O Material For Fornecido Pelo Usuário Final, Exceto Aviamento."
    },
    {
        "content": "14.10 - Tinturaria E Lavanderia.",
        "id": "14.10 - Tinturaria E Lavanderia."
    },
    {
        "content": "14.11 - Tapeçaria E Reforma De Estofamentos Em Geral.",
        "id": "14.11 - Tapeçaria E Reforma De Estofamentos Em Geral."
    },
    {
        "content": "14.12 - Funilaria E Lanternagem.",
        "id": "14.12 - Funilaria E Lanternagem."
    },
    {
        "content": "14.13 - Carpintaria E Serralheria.",
        "id": "14.13 - Carpintaria E Serralheria."
    },
    {
        "content": "14.14 - Guincho Intramunicipal, Guindaste E Içamento. (Incluído Pela Lei Complementar Nº 157, De 2016)",
        "id": "14.14 - Guincho Intramunicipal, Guindaste E Içamento. (Incluído Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "15.01 - Administração De Fundos Quaisquer, De Consórcio, De Cartão De Crédito Ou Débito E Congêneres, De Carteira De Clientes, De Cheques Pré-Datados E Congêneres.",
        "id": "15.01 - Administração De Fundos Quaisquer, De Consórcio, De Cartão De Crédito Ou Débito E Congêneres, De Carteira De Clientes, De Cheques Pré-Datados E Congêneres."
    },
    {
        "content": "15.02 - Abertura De Contas Em Geral, Inclusive Conta-Corrente, Conta De Investimentos E Aplicação E Caderneta De Poupança, No País E No Exterior, Bem Como A Manutenção Das Referidas Contas Ativas E Inativas.",
        "id": "15.02 - Abertura De Contas Em Geral, Inclusive Conta-Corrente, Conta De Investimentos E Aplicação E Caderneta De Poupança, No País E No Exterior, Bem Como A Manutenção Das Referidas Contas Ativas E Inativas."
    },
    {
        "content": "15.03 - Locação E Manutenção De Cofres Particulares, De Terminais Eletrônicos, De Terminais De Atendimento E De Bens E Equipamentos Em Geral.",
        "id": "15.03 - Locação E Manutenção De Cofres Particulares, De Terminais Eletrônicos, De Terminais De Atendimento E De Bens E Equipamentos Em Geral."
    },
    {
        "content": "15.04 - Fornecimento Ou Emissão De Atestados Em Geral, Inclusive Atestado De Idoneidade, Atestado De Capacidade Financeira E Congêneres.",
        "id": "15.04 - Fornecimento Ou Emissão De Atestados Em Geral, Inclusive Atestado De Idoneidade, Atestado De Capacidade Financeira E Congêneres."
    },
    {
        "content": "15.05 - Cadastro, Elaboração De Ficha Cadastral, Renovação Cadastral E Congêneres, Inclusão Ou Exclusão No Cadastro De Emitentes De Cheques Sem Fundos - CCF Ou Em Quaisquer Outros Bancos Cadastrais.",
        "id": "15.05 - Cadastro, Elaboração De Ficha Cadastral, Renovação Cadastral E Congêneres, Inclusão Ou Exclusão No Cadastro De Emitentes De Cheques Sem Fundos - CCF Ou Em Quaisquer Outros Bancos Cadastrais."
    },
    {
        "content": "15.06 - Emissão, Reemissão E Fornecimento De Avisos, Comprovantes E Documentos Em Geral; Abono De Firmas; Coleta E Entrega De Documentos, Bens E Valores; Comunicação Com Outra Agência Ou Com A Administração Central; Licenciamento Eletrônico De Veículos; Transferência De Veículos; Agenciamento Fiduciário Ou Depositário; Devolução De Bens Em Custódia.",
        "id": "15.06 - Emissão, Reemissão E Fornecimento De Avisos, Comprovantes E Documentos Em Geral; Abono De Firmas; Coleta E Entrega De Documentos, Bens E Valores; Comunicação Com Outra Agência Ou Com A Administração Central; Licenciamento Eletrônico De Veículos; Transferência De Veículos; Agenciamento Fiduciário Ou Depositário; Devolução De Bens Em Custódia."
    },
    {
        "content": "15.07 - Acesso, Movimentação, Atendimento E Consulta A Contas Em Geral, Por Qualquer Meio Ou Processo, Inclusive Por Telefone, Fac-Símile, Internet E Telex, Acesso A Terminais De Atendimento, Inclusive Vinte E Quatro Horas; Acesso A Outro Banco E À Rede Compartilhada; Fornecimento De Saldo, Extrato E Demais Informações Relativas A Contas Em Geral, Por Qualquer Meio Ou Processo.",
        "id": "15.07 - Acesso, Movimentação, Atendimento E Consulta A Contas Em Geral, Por Qualquer Meio Ou Processo, Inclusive Por Telefone, Fac-Símile, Internet E Telex, Acesso A Terminais De Atendimento, Inclusive Vinte E Quatro Horas; Acesso A Outro Banco E À Rede Compartilhada; Fornecimento De Saldo, Extrato E Demais Informações Relativas A Contas Em Geral, Por Qualquer Meio Ou Processo."
    },
    {
        "content": "15.08 - Emissão, Reemissão, Alteração, Cessão, Substituição, Cancelamento E Registro De Contrato De Crédito; Estudo, Análise E Avaliação De Operações De Crédito; Emissão, Concessão, Alteração Ou Contratação De Aval, Fiança, Anuência E Congêneres; Serviços Relativos À Abertura De Crédito, Para Quaisquer Fins.",
        "id": "15.08 - Emissão, Reemissão, Alteração, Cessão, Substituição, Cancelamento E Registro De Contrato De Crédito; Estudo, Análise E Avaliação De Operações De Crédito; Emissão, Concessão, Alteração Ou Contratação De Aval, Fiança, Anuência E Congêneres; Serviços Relativos À Abertura De Crédito, Para Quaisquer Fins."
    },
    {
        "content": "15.09 - Arrendamento Mercantil (Leasing) De Quaisquer Bens, Inclusive Cessão De Direitos E Obrigações, Substituição De Garantia, Alteração, Cancelamento E Registro De Contrato, E Demais Serviços Relacionados Ao Arrendamento Mercantil (Leasing).",
        "id": "15.09 - Arrendamento Mercantil (Leasing) De Quaisquer Bens, Inclusive Cessão De Direitos E Obrigações, Substituição De Garantia, Alteração, Cancelamento E Registro De Contrato, E Demais Serviços Relacionados Ao Arrendamento Mercantil (Leasing)."
    },
    {
        "content": "15.10 - Serviços Relacionados A Cobranças, Recebimentos Ou Pagamentos Em Geral, De Títulos Quaisquer, De Contas Ou Carnês, De Câmbio, De Tributos E Por Conta De Terceiros, Inclusive Os Efetuados Por Meio Eletrônico, Automático Ou Por Máquinas De Atendimento; Fornecimento De Posição De Cobrança, Recebimento Ou Pagamento; Emissão De Carnês, Fichas De Compensação, Impressos E Documentos Em Geral.",
        "id": "15.10 - Serviços Relacionados A Cobranças, Recebimentos Ou Pagamentos Em Geral, De Títulos Quaisquer, De Contas Ou Carnês, De Câmbio, De Tributos E Por Conta De Terceiros, Inclusive Os Efetuados Por Meio Eletrônico, Automático Ou Por Máquinas De Atendimento; Fornecimento De Posição De Cobrança, Recebimento Ou Pagamento; Emissão De Carnês, Fichas De Compensação, Impressos E Documentos Em Geral."
    },
    {
        "content": "15.11 - Devolução De Títulos, Protesto De Títulos, Sustação De Protesto, Manutenção De Títulos, Reapresentação De Títulos, E Demais Serviços A Eles Relacionados.",
        "id": "15.11 - Devolução De Títulos, Protesto De Títulos, Sustação De Protesto, Manutenção De Títulos, Reapresentação De Títulos, E Demais Serviços A Eles Relacionados."
    },
    {
        "content": "15.12 - Custódia Em Geral, Inclusive De Títulos E Valores Mobiliários.",
        "id": "15.12 - Custódia Em Geral, Inclusive De Títulos E Valores Mobiliários."
    },
    {
        "content": "15.13 - Serviços Relacionados A Operações De Câmbio Em Geral, Edição, Alteração, Prorrogação, Cancelamento E Baixa De Contrato De Câmbio; Emissão De Registro De Exportação Ou De Crédito; Cobrança Ou Depósito No Exterior; Emissão, Fornecimento E Cancelamento De Cheques De Viagem; Fornecimento, Transferência, Cancelamento E Demais Serviços Relativos A Carta De Crédito De Importação, Exportação E Garantias Recebidas; Envio E Recebimento De Mensagens Em Geral Relacionadas A Operações De Câmbio.",
        "id": "15.13 - Serviços Relacionados A Operações De Câmbio Em Geral, Edição, Alteração, Prorrogação, Cancelamento E Baixa De Contrato De Câmbio; Emissão De Registro De Exportação Ou De Crédito; Cobrança Ou Depósito No Exterior; Emissão, Fornecimento E Cancelamento De Cheques De Viagem; Fornecimento, Transferência, Cancelamento E Demais Serviços Relativos A Carta De Crédito De Importação, Exportação E Garantias Recebidas; Envio E Recebimento De Mensagens Em Geral Relacionadas A Operações De Câmbio."
    },
    {
        "content": "15.14 - Fornecimento, Emissão, Reemissão, Renovação E Manutenção De Cartão Magnético, Cartão De Crédito, Cartão De Débito, Cartão Salário E Congêneres.",
        "id": "15.14 - Fornecimento, Emissão, Reemissão, Renovação E Manutenção De Cartão Magnético, Cartão De Crédito, Cartão De Débito, Cartão Salário E Congêneres."
    },
    {
        "content": "15.15 - Compensação De Cheques E Títulos Quaisquer; Serviços Relacionados A Depósito, Inclusive Depósito Identificado, A Saque De Contas Quaisquer, Por Qualquer Meio Ou Processo, Inclusive Em Terminais Eletrônicos E De Atendimento.",
        "id": "15.15 - Compensação De Cheques E Títulos Quaisquer; Serviços Relacionados A Depósito, Inclusive Depósito Identificado, A Saque De Contas Quaisquer, Por Qualquer Meio Ou Processo, Inclusive Em Terminais Eletrônicos E De Atendimento."
    },
    {
        "content": "15.16 - Emissão, Reemissão, Liquidação, Alteração, Cancelamento E Baixa De Ordens De Pagamento, Ordens De Crédito E Similares, Por Qualquer Meio Ou Processo; Serviços Relacionados À Transferência De Valores, Dados, Fundos, Pagamentos E Similares, Inclusive Entre Contas Em Geral.",
        "id": "15.16 - Emissão, Reemissão, Liquidação, Alteração, Cancelamento E Baixa De Ordens De Pagamento, Ordens De Crédito E Similares, Por Qualquer Meio Ou Processo; Serviços Relacionados À Transferência De Valores, Dados, Fundos, Pagamentos E Similares, Inclusive Entre Contas Em Geral."
    },
    {
        "content": "15.17 - Emissão, Fornecimento, Devolução, Sustação, Cancelamento E Oposição De Cheques Quaisquer, Avulso Ou Por Talão.",
        "id": "15.17 - Emissão, Fornecimento, Devolução, Sustação, Cancelamento E Oposição De Cheques Quaisquer, Avulso Ou Por Talão."
    },
    {
        "content": "15.18 - Serviços Relacionados A Crédito Imobiliário, Avaliação E Vistoria De Imóvel Ou Obra, Análise Técnica E Jurídica, Emissão, Reemissão, Alteração, Transferência E Renegociação De Contrato, Emissão E Reemissão Do Termo De Quitação E Demais Serviços Relacionados A Crédito Imobiliário.",
        "id": "15.18 - Serviços Relacionados A Crédito Imobiliário, Avaliação E Vistoria De Imóvel Ou Obra, Análise Técnica E Jurídica, Emissão, Reemissão, Alteração, Transferência E Renegociação De Contrato, Emissão E Reemissão Do Termo De Quitação E Demais Serviços Relacionados A Crédito Imobiliário."
    },
    {
        "content": "16.01 - Serviços De Transporte Coletivo Municipal Rodoviário, Metroviário, Ferroviário E Aquaviário De Passageiros. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "16.01 - Serviços De Transporte Coletivo Municipal Rodoviário, Metroviário, Ferroviário E Aquaviário De Passageiros. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "16.02 - Outros Serviços De Transporte De Natureza Municipal. (Incluído Pela Lei Complementar Nº 157, De 2016)",
        "id": "16.02 - Outros Serviços De Transporte De Natureza Municipal. (Incluído Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "17.01 - Assessoria Ou Consultoria De Qualquer Natureza, Não Contida Em Outros Itens Desta Lista; Análise, Exame, Pesquisa, Coleta, Compilação E Fornecimento De Dados E Informações De Qualquer Natureza, Inclusive Cadastro E Similares.",
        "id": "17.01 - Assessoria Ou Consultoria De Qualquer Natureza, Não Contida Em Outros Itens Desta Lista; Análise, Exame, Pesquisa, Coleta, Compilação E Fornecimento De Dados E Informações De Qualquer Natureza, Inclusive Cadastro E Similares."
    },
    {
        "content": "17.02 - Datilografia, Digitação, Estenografia, Expediente, Secretaria Em Geral, Resposta Audível, Redação, Edição, Revisão, Apoio E Infra-Estrutura Administrativa E Congêneres.",
        "id": "17.02 - Datilografia, Digitação, Estenografia, Expediente, Secretaria Em Geral, Resposta Audível, Redação, Edição, Revisão, Apoio E Infra-Estrutura Administrativa E Congêneres."
    },
    {
        "content": "17.03 - Planejamento, Coordenação, Programação Ou Organização Técnica, Financeira Ou Administrativa.",
        "id": "17.03 - Planejamento, Coordenação, Programação Ou Organização Técnica, Financeira Ou Administrativa."
    },
    {
        "content": "17.04 - Recrutamento, Agenciamento, Seleção E Colocação De Mão-De-Obra.",
        "id": "17.04 - Recrutamento, Agenciamento, Seleção E Colocação De Mão-De-Obra."
    },
    {
        "content": "17.05 - Fornecimento De Mão-De-Obra, Mesmo Em Caráter Temporário, Inclusive De Empregados Ou Trabalhadores, Avulsos Ou Temporários, Contratados Pelo Prestador De Serviço.",
        "id": "17.05 - Fornecimento De Mão-De-Obra, Mesmo Em Caráter Temporário, Inclusive De Empregados Ou Trabalhadores, Avulsos Ou Temporários, Contratados Pelo Prestador De Serviço."
    },
    {
        "content": "17.06 - Propaganda E Publicidade, Inclusive Promoção De Vendas, Planejamento De Campanhas Ou Sistemas De Publicidade, Elaboração De Desenhos, Textos E Demais Materiais Publicitários.",
        "id": "17.06 - Propaganda E Publicidade, Inclusive Promoção De Vendas, Planejamento De Campanhas Ou Sistemas De Publicidade, Elaboração De Desenhos, Textos E Demais Materiais Publicitários."
    },
    {
        "content": "17.07 - (Vetado)",
        "id": "17.07 - (Vetado)"
    },
    {
        "content": "17.08 - Franquia (Franchising).",
        "id": "17.08 - Franquia (Franchising)."
    },
    {
        "content": "17.09 - Perícias, Laudos, Exames Técnicos E Análises Técnicas.",
        "id": "17.09 - Perícias, Laudos, Exames Técnicos E Análises Técnicas."
    },
    {
        "content": "17.10 - Planejamento, Organização E Administração De Feiras, Exposições, Congressos E Congêneres.",
        "id": "17.10 - Planejamento, Organização E Administração De Feiras, Exposições, Congressos E Congêneres."
    },
    {
        "content": "17.11 - Organização De Festas E Recepções; Bufê (Exceto O Fornecimento De Alimentação E Bebidas, Que Fica Sujeito Ao ICMS).",
        "id": "17.11 - Organização De Festas E Recepções; Bufê (Exceto O Fornecimento De Alimentação E Bebidas, Que Fica Sujeito Ao ICMS)."
    },
    {
        "content": "17.12 - Administração Em Geral, Inclusive De Bens E Negócios De Terceiros.",
        "id": "17.12 - Administração Em Geral, Inclusive De Bens E Negócios De Terceiros."
    },
    {
        "content": "17.13 - Leilão E Congêneres.",
        "id": "17.13 - Leilão E Congêneres."
    },
    {
        "content": "17.14 - Advocacia.",
        "id": "17.14 - Advocacia."
    },
    {
        "content": "17.15 - Arbitragem De Qualquer Espécie, Inclusive Jurídica.",
        "id": "17.15 - Arbitragem De Qualquer Espécie, Inclusive Jurídica."
    },
    {
        "content": "17.16 - Auditoria.",
        "id": "17.16 - Auditoria."
    },
    {
        "content": "17.17 - Análise De Organização E Métodos.",
        "id": "17.17 - Análise De Organização E Métodos."
    },
    {
        "content": "17.18 - Atuária E Cálculos Técnicos De Qualquer Natureza.",
        "id": "17.18 - Atuária E Cálculos Técnicos De Qualquer Natureza."
    },
    {
        "content": "17.19 - Contabilidade, Inclusive Serviços Técnicos E Auxiliares.",
        "id": "17.19 - Contabilidade, Inclusive Serviços Técnicos E Auxiliares."
    },
    {
        "content": "17.20 - Consultoria E Assessoria Econômica Ou Financeira.",
        "id": "17.20 - Consultoria E Assessoria Econômica Ou Financeira."
    },
    {
        "content": "17.21 - Estatística.",
        "id": "17.21 - Estatística."
    },
    {
        "content": "17.22 - Cobrança Em Geral.",
        "id": "17.22 - Cobrança Em Geral."
    },
    {
        "content": "17.23 - Assessoria, Análise, Avaliação, Atendimento, Consulta, Cadastro, Seleção, Gerenciamento De Informações, Administração De Contas A Receber Ou A Pagar E Em Geral, Relacionados A Operações De Faturização (Factoring).",
        "id": "17.23 - Assessoria, Análise, Avaliação, Atendimento, Consulta, Cadastro, Seleção, Gerenciamento De Informações, Administração De Contas A Receber Ou A Pagar E Em Geral, Relacionados A Operações De Faturização (Factoring)."
    },
    {
        "content": "17.24 - Apresentação De Palestras, Conferências, Seminários E Congêneres.",
        "id": "17.24 - Apresentação De Palestras, Conferências, Seminários E Congêneres."
    },
    {
        "content": "17.25 - Inserção De Textos, Desenhos E Outros Materiais De Propaganda E Publicidade, Em Qualquer Meio (Exceto Em Livros, Jornais, Periódicos E Nas Modalidades De Serviços De Radiodifusão Sonora E De Sons E Imagens De Recepção Livre E Gratuita). (Incluído Pela Lei Complementar Nº 157, De 2016)",
        "id": "17.25 - Inserção De Textos, Desenhos E Outros Materiais De Propaganda E Publicidade, Em Qualquer Meio (Exceto Em Livros, Jornais, Periódicos E Nas Modalidades De Serviços De Radiodifusão Sonora E De Sons E Imagens De Recepção Livre E Gratuita). (Incluído Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "18.01 - Serviços De Regulação De Sinistros Vinculados A Contratos De Seguros; Inspeção E Avaliação De Riscos Para Cobertura De Contratos De Seguros; Prevenção E Gerência De Riscos Seguráveis E Congêneres.",
        "id": "18.01 - Serviços De Regulação De Sinistros Vinculados A Contratos De Seguros; Inspeção E Avaliação De Riscos Para Cobertura De Contratos De Seguros; Prevenção E Gerência De Riscos Seguráveis E Congêneres."
    },
    {
        "content": "19.01 - Serviços De Distribuição E Venda De Bilhetes E Demais Produtos De Loteria, Bingos, Cartões, Pules Ou Cupons De Apostas, Sorteios, Prêmios, Inclusive Os Decorrentes De Títulos De Capitalização E Congêneres.",
        "id": "19.01 - Serviços De Distribuição E Venda De Bilhetes E Demais Produtos De Loteria, Bingos, Cartões, Pules Ou Cupons De Apostas, Sorteios, Prêmios, Inclusive Os Decorrentes De Títulos De Capitalização E Congêneres."
    },
    {
        "content": "20.01 - Serviços Portuários, Ferroportuários, Utilização De Porto, Movimentação De Passageiros, Reboque De Embarcações, Rebocador Escoteiro, Atracação, Desatracação, Serviços De Praticagem, Capatazia, Armazenagem De Qualquer Natureza, Serviços Acessórios, Movimentação De Mercadorias, Serviços De Apoio Marítimo, De Movimentação Ao Largo, Serviços De Armadores, Estiva, Conferência, Logística E Congêneres.",
        "id": "20.01 - Serviços Portuários, Ferroportuários, Utilização De Porto, Movimentação De Passageiros, Reboque De Embarcações, Rebocador Escoteiro, Atracação, Desatracação, Serviços De Praticagem, Capatazia, Armazenagem De Qualquer Natureza, Serviços Acessórios, Movimentação De Mercadorias, Serviços De Apoio Marítimo, De Movimentação Ao Largo, Serviços De Armadores, Estiva, Conferência, Logística E Congêneres."
    },
    {
        "content": "20.02 - Serviços Aeroportuários, Utilização De Aeroporto, Movimentação De Passageiros, Armazenagem De Qualquer Natureza, Capatazia, Movimentação De Aeronaves, Serviços De Apoio Aeroportuários, Serviços Acessórios, Movimentação De Mercadorias, Logística E Congêneres.",
        "id": "20.02 - Serviços Aeroportuários, Utilização De Aeroporto, Movimentação De Passageiros, Armazenagem De Qualquer Natureza, Capatazia, Movimentação De Aeronaves, Serviços De Apoio Aeroportuários, Serviços Acessórios, Movimentação De Mercadorias, Logística E Congêneres."
    },
    {
        "content": "20.03 - Serviços De Terminais Rodoviários, Ferroviários, Metroviários, Movimentação De Passageiros, Mercadorias, Inclusive Suas Operações, Logística E Congêneres.",
        "id": "20.03 - Serviços De Terminais Rodoviários, Ferroviários, Metroviários, Movimentação De Passageiros, Mercadorias, Inclusive Suas Operações, Logística E Congêneres."
    },
    {
        "content": "21.01 - Serviços De Registros Públicos, Cartorários E Notariais.",
        "id": "21.01 - Serviços De Registros Públicos, Cartorários E Notariais."
    },
    {
        "content": "22.01 - Serviços De Exploração De Rodovia Mediante Cobrança De Preço Ou Pedágio Dos Usuários, Envolvendo Execução De Serviços De Conservação, Manutenção, Melhoramentos Para Adequação De Capacidade E Segurança De Trânsito, Operação, Monitoração, Assistência Ao Usuários E Outros Serviços Definidos Em Contratos, Atos De Concessão Ou De Permissão Ou Em Normas Oficiais.",
        "id": "22.01 - Serviços De Exploração De Rodovia Mediante Cobrança De Preço Ou Pedágio Dos Usuários, Envolvendo Execução De Serviços De Conservação, Manutenção, Melhoramentos Para Adequação De Capacidade E Segurança De Trânsito, Operação, Monitoração, Assistência Ao Usuários E Outros Serviços Definidos Em Contratos, Atos De Concessão Ou De Permissão Ou Em Normas Oficiais."
    },
    {
        "content": "23.01 - Serviços De Programação E Comunicação Visual, Desenho Industrial E Congêneres.",
        "id": "23.01 - Serviços De Programação E Comunicação Visual, Desenho Industrial E Congêneres."
    },
    {
        "content": "24.01 - Serviços De Chaveiros, Confecção De Carimbos, Placas, Sinalização Visual, Banners, Adesivos E Congêneres.",
        "id": "24.01 - Serviços De Chaveiros, Confecção De Carimbos, Placas, Sinalização Visual, Banners, Adesivos E Congêneres."
    },
    {
        "content": "25.01 - Funerais, Inclusive Fornecimento De Caixão, Urna Ou Esquifes; Aluguel De Capela; Transporte Do Corpo Cadavérico; Fornecimento De Flores, Coroas E Outros Paramentos; Desembaraço De Certidão De Óbito; Fornecimento De Véu, Essa E Outros Adornos; Embalsamento, Embelezamento, Conservação Ou Restauração De Cadáveres.",
        "id": "25.01 - Funerais, Inclusive Fornecimento De Caixão, Urna Ou Esquifes; Aluguel De Capela; Transporte Do Corpo Cadavérico; Fornecimento De Flores, Coroas E Outros Paramentos; Desembaraço De Certidão De Óbito; Fornecimento De Véu, Essa E Outros Adornos; Embalsamento, Embelezamento, Conservação Ou Restauração De Cadáveres."
    },
    {
        "content": "25.02 - Translado Intramunicipal E Cremação De Corpos E Partes De Corpos Cadavéricos. (Redação Dada Pela Lei Complementar Nº 157, De 2016)",
        "id": "25.02 - Translado Intramunicipal E Cremação De Corpos E Partes De Corpos Cadavéricos. (Redação Dada Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "25.03 - Planos Ou Convênio Funerários.",
        "id": "25.03 - Planos Ou Convênio Funerários."
    },
    {
        "content": "25.04 - Manutenção E Conservação De Jazigos E Cemitérios.",
        "id": "25.04 - Manutenção E Conservação De Jazigos E Cemitérios."
    },
    {
        "content": "25.05 - Cessão De Uso De Espaços Em Cemitérios Para Sepultamento. (Incluído Pela Lei Complementar Nº 157, De 2016)",
        "id": "25.05 - Cessão De Uso De Espaços Em Cemitérios Para Sepultamento. (Incluído Pela Lei Complementar Nº 157, De 2016)"
    },
    {
        "content": "26.01 - Serviços De Coleta, Remessa Ou Entrega De Correspondências, Documentos, Objetos, Bens Ou Valores, Inclusive Pelos Correios E Suas Agências Franqueadas; Courrier E Congêneres.",
        "id": "26.01 - Serviços De Coleta, Remessa Ou Entrega De Correspondências, Documentos, Objetos, Bens Ou Valores, Inclusive Pelos Correios E Suas Agências Franqueadas; Courrier E Congêneres."
    },
    {
        "content": "27.01 - Serviços De Assistência Social.",
        "id": "27.01 - Serviços De Assistência Social."
    },
    {
        "content": "28.01 - Serviços De Avaliação De Bens E Serviços De Qualquer Natureza.",
        "id": "28.01 - Serviços De Avaliação De Bens E Serviços De Qualquer Natureza."
    },
    {
        "content": "29.01 - Serviços De Biblioteconomia.",
        "id": "29.01 - Serviços De Biblioteconomia."
    },
    {
        "content": "30.01 - Serviços De Biologia, Biotecnologia E Química.",
        "id": "30.01 - Serviços De Biologia, Biotecnologia E Química."
    },
    {
        "content": "31.01 - Serviços Técnicos Em Edificações, Eletrônica, Eletrotécnica, Mecânica, Telecomunicações E Congêneres.",
        "id": "31.01 - Serviços Técnicos Em Edificações, Eletrônica, Eletrotécnica, Mecânica, Telecomunicações E Congêneres."
    },
    {
        "content": "32.01 - Serviços De Desenhos Técnicos.",
        "id": "32.01 - Serviços De Desenhos Técnicos."
    },
    {
        "content": "33.01 - Serviços De Desembaraço Aduaneiro, Comissários, Despachantes E Congêneres.",
        "id": "33.01 - Serviços De Desembaraço Aduaneiro, Comissários, Despachantes E Congêneres."
    },
    {
        "content": "34.01 - Serviços De Investigações Particulares, Detetives E Congêneres.",
        "id": "34.01 - Serviços De Investigações Particulares, Detetives E Congêneres."
    },
    {
        "content": "35.01 - Serviços De Reportagem, Assessoria De Imprensa, Jornalismo E Relações Públicas.",
        "id": "35.01 - Serviços De Reportagem, Assessoria De Imprensa, Jornalismo E Relações Públicas."
    },
    {
        "content": "36.01 - Serviços De Meteorologia.",
        "id": "36.01 - Serviços De Meteorologia."
    },
    {
        "content": "37.01 - Serviços De Artistas, Atletas, Modelos E Manequins.",
        "id": "37.01 - Serviços De Artistas, Atletas, Modelos E Manequins."
    },
    {
        "content": "38.01 - Serviços De Museologia.",
        "id": "38.01 - Serviços De Museologia."
    },
    {
        "content": "39.01 - Serviços De Ourivesaria E Lapidação (Quando O Material For Fornecido Pelo Tomador Do Serviço).",
        "id": "39.01 - Serviços De Ourivesaria E Lapidação (Quando O Material For Fornecido Pelo Tomador Do Serviço)."
    },
    {
        "content": "40.01 - Obras De Arte Sob Encomenda.",
        "id": "40.01 - Obras De Arte Sob Encomenda."
    }
]);

export default itensLC116;
